import * as React from "react";
const SvgIcDiamondFilled = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m5 2.5-3.333 5L10 18.333 18.333 7.5 15 2.5H5Z" /></svg>;
export default SvgIcDiamondFilled;